import EfhFooterNavV2 from 'eco-design/section-layout/ef-footer-v2';
import FooterCookieSettingA from '../Footer/FooterCookieSettingA';
import FooterNoShareA from '../Footer/FooterNoShareA';
import FooterEmailA from './FooterEmailA';
import FooterB1 from './FooterB1';
import FooterC1 from './FooterC1';
import FooterLangTextA from './FooterLangTextA';
import './index.scss';

export default function Footer({ locale, navItems = [], theme = 'black' }: { locale: string; navItems: any[]; theme: 'white' | 'black' | 'gray' }) {
    const TextA = FooterLangTextA[locale] || FooterLangTextA['us']; //服务器会只返回该站点的文案
    return (
        <footer className={`global-footer global-footer-theme-${theme}`}>
            <div className="global-footer-content-a1">
                <EfhFooterNavV2 items={navItems} theme={theme} />
                <FooterEmailA locale={locale} TextA={TextA} theme={theme} />
            </div>
            <div className="global-footer-content-v2">
                <FooterB1 locale={locale} TextA={TextA} theme={theme} />
                <FooterC1 locale={locale} TextA={TextA} theme={theme} />
                <FooterNoShareA />
                <FooterCookieSettingA />
            </div>
        </footer>
    );
}
